import { useT } from "@/lib/i18n";

export const LangSwitch = () => {
  const { lang, setLang } = useT();
  return (
    <div data-testid="lang-switch" className="flex border border-[#282D3D] rounded-sm overflow-hidden font-mono text-xs">
      {["it", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}-btn`}
          onClick={() => setLang(l)}
          className={`px-2.5 py-1.5 uppercase tracking-wider transition-colors duration-200 ${
            lang === l ? "bg-[#FF3B30] text-white" : "text-slate-400 hover:text-white hover:bg-[#181B26]"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
